import * as Rest from 'src/constants/rest'
import { TipoMensaje } from 'src/enums/EscritosLegales'
import { EstadoMensaje, EstadoLexnetMensaje } from 'src/enums/EstadoMensaje'
import { Mensaje } from 'src/interfaces'
import http from 'src/utils/Http'

export interface GetMessagesResponse {
  results: Mensaje[]
  total: number
  page: number
  itemsPerPage: number
}

export function getMessages(
  filters: {
    estado: EstadoMensaje[]
    estadoLexnet: EstadoLexnetMensaje[]
    tipoMensaje: TipoMensaje[]
  },
  page = 1,
  itemsPerPage = 10,
  sortBy: { id: string; desc: boolean }[],
  searchedText: string
): Promise<GetMessagesResponse> {
  const sortByQuery = sortBy.reduce(
    (acc, item) => ({
      ...acc,
      [`order[${item.id}]`]: item.desc ? 'desc' : 'asc'
    }),
    {}
  )
  return http
    .get({
      url: Rest.MESSAGES,
      token: true,
      params: {
        itemsPerPage,
        page,
        'estado[]': (filters.estado.length === 1 && filters.estado[0] === EstadoMensaje.INITIAL) ? '0' : filters.estado,
        'estadoLexnet[]': (filters.estadoLexnet.length === 1 && filters.estadoLexnet[0] === EstadoLexnetMensaje.INITIAL)
          ? 0
          : filters.estadoLexnet,
        'tipoMensaje[]': filters.tipoMensaje,
        searchedText,
        ...sortByQuery
      }
    })
    .then(res => ({
      results: res.mensajes,
      total: res.total,
      page,
      itemsPerPage: res.itemsPerPage
    }))
}

export interface GetMessageResponse {
  results: Mensaje
  total: number
  page: number
}

export function getMessage(messageId: string): Promise<GetMessageResponse> {
  return http
    .get({
      url: Rest.MESSAGE(messageId),
      token: true
    })
    .then(res => ({
      results: res,
      total: 1,
      page: 1
    }))
}

export function markAsReadMessage(
  messageId: string
): Promise<{
  idEnvio: string
  document: string
}> {
  return http.post({
    url: Rest.MESSAGE_READ(messageId),
    token: true
  })
}

export function markAsReadMessageSigned(
  idEnvio: string,
  signedDocument: string
): Promise<{
  messageCades: string
  token: string
}> {
  return http
    .post({
      url: Rest.MESSAGE_READ_SIGN(),
      token: true,
      params: {
        idEnvio,
        firmaDocumento: signedDocument
      }
    })
    .then(res => ({
      messageCades: res.mensaje,
      token: res.token
    }))
}

export function makeSend(
  idEnvio: string,
  signedToken: string,
  signedMessageHash: string
): Promise<any> {
  return http.post({
    url: Rest.MAKE_SEND(),
    token: true,
    params: {
      idEnvio,
      firmaToken: signedToken,
      content: signedMessageHash
    }
  })
}

export function downloadMessage(mensajeId: string): Promise<any> {
  return http.post({
    url: Rest.MESSAGE_DOWNLOAD(mensajeId),
    token: true
  })
}

export function getAceptadosRechazados(): Promise<any> {
  return http.get({
    url: Rest.ACCEPTED_REJECTED,
    token: true
  })
}
